/**
 * Debug helper for voucher logging
 * Enable by setting window.VOUCHER_DEBUG = true in browser console
 */
const isVoucherDebugEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  if (window.VOUCHER_DEBUG === true) {
    return true
  }

  try {
    return window.localStorage?.getItem('VOUCHER_DEBUG') === 'true'
  } catch (_err) {
    return false
  }
}

export const voucherDebug = (...args) => {
  if (isVoucherDebugEnabled()) {
    console.log('[Voucher]', ...args)
  }
}

export const voucherDebugWarn = (...args) => {
  if (isVoucherDebugEnabled()) {
    console.warn('[Voucher]', ...args)
  }
}

export const voucherDebugError = (...args) => {
  if (isVoucherDebugEnabled()) {
    console.error('[Voucher]', ...args)
  }
}

export const enableVoucherDebug = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.VOUCHER_DEBUG = true
  try {
    window.localStorage?.setItem('VOUCHER_DEBUG', 'true')
  } catch (_err) {}
}

export const disableVoucherDebug = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.VOUCHER_DEBUG = false
  try {
    window.localStorage?.removeItem('VOUCHER_DEBUG')
  } catch (_err) {}
}
